import { httpsCallable } from 'firebase/functions';
import { functions } from '../../lib/firebase';

// Thin wrappers over the Admin-SDK callables (gated owner/hqadmin server-side).
// Using callables keeps the calling admin's session intact.
export function adminCreateUser(payload) {
  return httpsCallable(functions, 'adminCreateUser')(payload).then((r) => r.data);
}

export function adminUpdateUser(payload) {
  return httpsCallable(functions, 'adminUpdateUser')(payload).then((r) => r.data);
}

export function adminSetUserActive(uid, active) {
  return httpsCallable(functions, 'adminSetUserActive')({ uid, active }).then((r) => r.data);
}

// Permanent user deletion (2026-07-21): profile + Auth login removed, their
// leads unassigned — every step audited server-side. HQ: anyone but self;
// owners: managers/agents in owned tenants only.
export function adminDeleteUser(uid) {
  return httpsCallable(functions, 'adminDeleteUser')({ uid }).then((r) => r.data);
}
